import { Card, Space } from "antd";
import SingleRatingIcon from "../../../../assets/icons/SingleRatingIcon";
import UsersIcon from "../../../../assets/icons/UsersIcon";
import WalletIcon from "../../../../assets/icons/WalletIcon";

interface CourseCardProps {
  image: string;
  title: string;
  rating: number;
  students: number;
  price: number;
}

export const CourseCard: React.FC<CourseCardProps> = ({
  image,
  title,
  rating,
  students,
  price,
}) => {
  return (
    <Card
      hoverable
      className="rounded-xl overflow-hidden shadow-sm"
      bodyStyle={{ padding: "12px" }}
      cover={
        <img
          src={image}
          alt={title}
          className="h-[160px] w-full object-cover"
        />
      }
    >
      <div className="justify-start text-zinc-700 text-base font-medium">
        {title}
      </div>

      <div className="flex items-center gap-2 text-xs text-gray-500">
        <Space size={4} align="center">
          <SingleRatingIcon className="text-[#FC8415] text-sm" />

          <div className="justify-start text-slate-600 text-sm font-normal mt-1">
            {rating}
          </div>
        </Space>
        <Space size={4} align="center">
          <UsersIcon className="text-[#455468] text-lg" />

          <div className="justify-start text-slate-600 text-sm font-normal mt-1">
            {students}
          </div>
        </Space>
        <Space size={4} align="center">
          <WalletIcon className="text-[#455468] text-lg" />

          <div className="justify-start text-slate-600 text-sm font-normal mt-1">
            {price.toLocaleString()}
          </div>
        </Space>
      </div>
    </Card>
  );
};
